export const DEFAULT_TIMEOUT = 300000; // 5 minutes
// export const DEFAULT_TIMEOUT = 30000; // 30 seconds

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
};
export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	INSTITUTES: "/institutes",
	APPLICATIONS: "/applications",
	TRACK_APPLICATIONS: "/applications/draft",
	TRACK_APPLICATIONS_BY_ID: "/applications/draft",
	COURSES: "/courses",
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	DISTRICT_BY_DIVISION: "/districts-by-division",
	LOCATIONS: "/locations",
	DIVISIONS: "/divisions",
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
	UPDATE_HEAD_NAME: (id: string | number) => `/applications/${id}/head-name`,
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/login",
		SIGN_UP: "/email/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		CHANGE_PASSWORD: "/change-password",
		VERIFY_OTP: "/verify-otp",
		RESEND_OTP: "/resend-otp",
		VERIFY_RESET_TOKEN: "/verify-reset-token",
		RESEND_VERIFICATION_LINK: "/resend-verification-link",
	},
	PAYMENT: {
		PAY_CHALLAN: "/pay-challan",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
	},
	INSTITUTES: {
		MY_INSTITUTES: "/institutes/my-institutes",
		INSTITUTE_APPLICATIONS: (instituteId: string | number) => `/applications/institutes/${instituteId}/`,
		INSTITUTE_STATUS: "/applications/institute-status",
		UNAUTHORIZED_INSTITUTE_REPORT: "/unauthorized-institutes/reports",
		CHECK_DUPLICATE_FIELD: "/institutes/check-duplicate",
		APPLICATIONS: {
			INSTITUTE_DETAIL: (uuid: string) => `/applications/${uuid}/register`,
			BUILDING_DETAIL: "/applications/building-detail",
			APPLICATION_ATTACHMENT: "/applications/application-attachment",
			SUBMIT: "/applications/{id}/submit",
			ADD_COURSE_STREAM: "/applications/{id}/add-course-stream",
			RENEW_WITHOUT_TRADE: "/applications/renew-without-trade",
			RENEW: "/applications/renew",
			UPDATE_HEAD_NAME: "/applications/{id}/head-name",
			UPDATE_INSTITUTE_DETAIL: (id: string | number) => `/applications/${id}/institute-detail`,
			UPDATE_BUILDING_DETAILS: (id: string | number) => `/applications/${id}/building-detail`,
			UPDATE_ATTACHMENT_DETAILS: (id: string | number) => `/applications/${id}/application-attachment`,
			RENEW_WITH_CHANGE: "/applications/renew-with-change",
			RENEW_WITH_BUILDING_DETAILS: "/applications/renew-with-building-details",
			RENEW_WITH_CHANGE_OF_NAME: "/applications/renew-with-change-of-name",
			RENEW_WITH_CHANGE_OF_ADDRESS: "/applications/renew-with-change-of-address",
			RENEW_WITH_CHANGE_OF_OWNERSHIP: "/applications/renew-with-change-of-ownership",
			RENEW_WITH_TRADE: "/applications/renew-with-trade",
			REFERBACK: (id: string | number) => `/applications/${id}/referback`,
			REFERBACK_INSTITUTE_DETAILS: (id: string | number) => `/applications/${id}/referback/institute-details`,
			BASIC_DETAIL: (uuid: string) => `/applications/${uuid}/basic-detail`,
			GET_BUILDING_DETAIL: (uuid: string) => `/applications/${uuid}/building-detail`,
			GET_ATTACHMENT_DETAIL: (uuid: string) => `/applications/${uuid}/application-attachment`,
			BASIC_DETAIL_WITH_SCRUTINY: (uuid: string) => `/applications/${uuid}/basic-detail-with-scrutiny`,
			BUILDING_DETAIL_WITH_SCRUTINY: (uuid: string) => `/applications/${uuid}/building-details-with-scrutiny`,
			ATTACHMENT_DETAIL_WITH_SCRUTINY: (uuid: string) => `/applications/${uuid}/attachment-details-with-scrutiny`,
			UPDATE_REFERBACK_FIELD: (id: string | number) => `/applications/${id}/referback/field`,
			RESUBMIT_REFERBACK: (id: string | number) => `/applications/${id}/resubmit-institute-details`,
			UPDATE_BASIC_DETAIL: (id: string | number) => `/application-referback/${id}/update-basic-detail`,
			UPDATE_BUILDING_DETAIL: (id: string | number) => `/application-referback/${id}/update-building-detail`,
			UPDATE_ATTACHMENT_DETAIL: (id: string | number) => `/application-referback/${id}/update-attachment-detail`,
			UPDATE_COURSE_DETAIL: (id: string | number) => `/application-referback/${id}/update-course-detail`,
			GET_APPLICATION_COURSES: (id: string | number) => `/applications/${id}/application-courses`,
			GET_APPLICATION_COURSE: (id: string | number, applicationCourseId: string | number) =>
				`/applications/${id}/application-courses/${applicationCourseId}`,
			UPDATE_APPLICATION_COURSE: (id: string | number, applicationCourseId: string | number) =>
				`/applications/${id}/application-courses/${applicationCourseId}`,
			UPDATE_LAB_EQUIPMENTS: (id: string | number, applicationCourseId: string | number) =>
				`/applications/${id}/application-courses/${applicationCourseId}/lab-equipments`,
			RESUBMIT_APPLICATION: (id: string | number) => `/applications/${id}/resubmit-application`,
			APPEAL: "/applications/appeal",
			APPEALS_LIST: "/applications/appeals",
			CERTIFICATE: (uuid: string) => `/applications/${uuid}/certificate`,
		},
		ORGANIZATION_TYPE: "/organization-type",
		ORGANIZATION_CATEGORY: "/system/organization-category",
		ORGANIZATION_COMPANY: "/organization-company",
		PROVINCE: "/province",
		COUNTRY: "/country",
		DIVISION: "/division",
		DISTRICT: "/district",
		CITY: "/city",
		TEHSIL: "/tehsil",
		UNION_COUNCIL: "/union-council",
		NATIONAL_ASSEMBLY: "/national-assembly",
		PROVISIONAL_ASSEMBLY: "/provisional-assembly",
		GENDER: "/gender",
		EDUCATION_TYPE: "/education-type",
		CAMPUS_TYPE: "/campus-type",
		INSTITUTE_STREAM: "/institute-stream",
		BANK: "/bank",
		FACILITY_TYPES: "/institutes/facility-types",
		ATTACHMENT_TYPES: "/institutes/attachment-types",
		FILE_UPLOAD_URL: "/attachments/upload",
		COURSE_STREAM: "/course-stream",
		COURSE_LIST: "/course",
		COURSE_BY_UUID: (courseUuid: string) => `/course/${courseUuid}`,
		PUBLIC_COURSE_LIST: "/public/course",
		ASSIGNED_COURSES: (instituteId: string | number) => `/${instituteId}/assigned-courses`,
		QUALIFICATION: "/qualification",
		DESIGNATION: "/designation",
		TECHNOLOGY: "/technology",
		COURSE_LABS: "/labs/courses",
		LAB_BY_UUID: (labUuid: string) => `/labs/${labUuid}`,
		ATTACHMENT_UPLOAD: "/attachments/upload",
		ATTACHMENT_PREVIEW: "/attachments",
		AFFIDAVIT_GET: "/affidavit/get",
		APPLICATION_COURSE: "/applications/application-course",
		APPLICATION_DRAFT: "/applications/draft",
		FACULTY: {
			LIST: (instituteUuid: string | number) => `/faculty-member/institute/${instituteUuid}`,
			ADD: "/faculty-member",
			UPDATE: "/faculty-member",
			DELETE: "/faculty-member",
			ADD_EDUCATION: (facultyId: string | number) => `/faculty-member/${facultyId}/educations`,
			UPDATE_EDUCATION: (facultyId: string | number, educationId: string | number) =>
				`/faculty-member/${facultyId}/educations/${educationId}`,
			ADD_CERTIFICATE: (facultyMemberId: string | number) => `/faculty-member/${facultyMemberId}/certificates`,
			UPDATE_CERTIFICATE: (facultyMemberId: string | number, certificateId: string | number) =>
				`/faculty-member/${facultyMemberId}/certificates/${certificateId}`,
		},
		BATCHES: (instituteId: string | number) => `/institutes/${instituteId}/batches`,
		TRADE_SESSION_STUDENTS: (sessionUuid: string) => `/trade-session/${sessionUuid}/students`,
		STUDENT_ATTENDANCE: "/student-attendance",
		STUDENT_ATTENDANCE_BULK: "/student-attendance/bulk",
		ENROLLMENT_ATTENDANCES_BY_SUBJECT: (enrollmentUuid: string) => `/enrollments/${enrollmentUuid}/attendances-by-subject`,
		DROPOUT_REASONS: "/dropout-reason",
		STUDENT_DROPOUT: "/student-dropout",
		STUDENT_DROPOUT_REVERT: (enrollmentUuid: string) =>
			`/student-dropout/enrollment/${enrollmentUuid}/revert`,
		STUDENT_PROMOTION_BY_INSTITUTE: (instituteId: string | number) =>
			`/student-promotion/institute/${instituteId}`,
		STUDENT_PROMOTION_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`/student-promotion/enrollment/${enrollmentUuid}`,
		STUDENT_PROMOTION_PROMOTE: "/student-promotion/promote",
		STUDENT_PROMOTION_BULK_PROMOTE: "/student-promotion/bulk-promote",
		STUDENT_PROMOTION_REVERT: (enrollmentUuid: string) =>
			`/student-promotion/enrollment/${enrollmentUuid}/revert`,
		STUDENT_PROMOTION_HISTORY: (enrollmentUuid: string) =>
			`/student-promotion/enrollment/${enrollmentUuid}/history`,
		FACULTY_ATTENDANCE: "/faculty-attendance",
		FACULTY_ATTENDANCE_BULK: "/faculty-attendance/bulk",
		FACULTY_ATTENDANCE_BY_FACULTY_AND_INSTITUTE: (facultyMemberUuid: string, instituteUuid: string) => `/faculty-attendance/faculty/${facultyMemberUuid}/institute/${instituteUuid}`,
		FACULTY_ATTENDANCE_DETAILS: (facultyMemberUuid: string, instituteUuid: string) => `/faculty-attendance/faculty/${facultyMemberUuid}/institute/${instituteUuid}/attendances`,
		FACULTY_MEMBER_ATTENDANCES_BY_SUBJECT: (facultyMemberUuid: string) => `/faculty-members/${facultyMemberUuid}/attendances-by-subject`,
		RESULT_STUDENTS: (instituteId: string | number) =>
			`/students/institute/${instituteId}/result-students`,
		INSTITUTE_STUDENTS_WITH_OUTCOMES: (instituteId: string | number) =>
			`/students/institute/${instituteId}/students`,
		INSTITUTE_STUDENT_OUTCOME: (instituteId: string | number, studentUuid: string) =>
			`/students/institute/${instituteId}/${studentUuid}/outcome`,
		INSTITUTE_STUDENT_EMPLOYMENTS: (instituteId: string | number, studentUuid: string) =>
			`/students/institute/${instituteId}/${studentUuid}/employments`,
		INSTITUTE_STUDENT_EMPLOYMENT_BY_ID: (
			instituteId: string | number,
			studentUuid: string,
			employmentId: string,
		) => `/students/institute/${instituteId}/${studentUuid}/employments/${employmentId}`,
		INSTITUTE_STUDENT_HIGHER_STUDIES: (instituteId: string | number, studentUuid: string) =>
			`/students/institute/${instituteId}/${studentUuid}/higher-studies`,
		INSTITUTE_STUDENT_HIGHER_STUDY_BY_ID: (
			instituteId: string | number,
			studentUuid: string,
			studyId: string,
		) => `/students/institute/${instituteId}/${studentUuid}/higher-studies/${studyId}`,
		EMPLOYERS: "/employers",
		OUTCOME_JOB_TYPES: "/outcome-job-type",
		COURSE_RESULT_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`/course-result/enrollment/${enrollmentUuid}`,
		COURSE_RESULT: "/course-result",
		COURSE_RESULT_BY_UUID: (resultUuid: string) => `/course-result/${resultUuid}`,
		CBTA_COURSE_RESULT_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`/cbta-course-result/enrollment/${enrollmentUuid}`,
		CBTA_COURSE_RESULT: "/cbta-course-result",
		CBTA_COURSE_RESULT_MODULE: (moduleResultUuid: string) =>
			`/cbta-course-result/module/${moduleResultUuid}`,
		CBTA_COURSE_RESULT_HEADER: (headerUuid: string) => `/cbta-course-result/${headerUuid}`,
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: (instituteId: string | number) => `/institutes/${instituteId}/challan-stats`,
	},
	E_CHALLAN_STATUS: {
		E_CHALLAN_STATUS: "/e-challan-status",
		CHALLANS: "/applications/challans",
	},
	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	COURSES: {
		EQUIPMENT: "/equipment",
		INSTITUTE_COURSES: "/institutes/institute-courses",
		INSTITUTE_COURSES_BY_ID: (instituteId: string | number) => `/${instituteId}/institute-courses`,
	},
	ADMISSIONS: {
		CREATE: "/institutes/admissions",
		QUOTA: "/institutes/admission-quota",
	},
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		CHANGE_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.CHANGE_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
		VERIFY_RESET_TOKEN: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_RESET_TOKEN,
		RESEND_VERIFICATION_LINK: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_VERIFICATION_LINK,
	},
	PUBLIC_REPORTS: {
		UNAUTHORIZED_INSTITUTE_REPORT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.UNAUTHORIZED_INSTITUTE_REPORT,
	},
	PAYMENT: {
		PAY_CHALLAN: API_ROUTES.INSTITUTES + "/applications/pay-challan",
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,

		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
	},
	INSTITUTES: {
		SYSTEM_FILTERS: {
			APPLICATION_SESSIONS: API_ROUTES.INSTITUTES + "/academic-calendars",
			QUALIFICATION_LEVEL: API_ROUTES.INSTITUTES + "/system/filters/qualification-level",
		},
		INSTITUTE_STATUS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.INSTITUTE_STATUS,
		MY_INSTITUTES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.MY_INSTITUTES,
		CHECK_DUPLICATE_FIELD: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.CHECK_DUPLICATE_FIELD,

		APPLICATIONS: {
			RECENT: (instituteId: string | number) => `/institutes/applications/recent/${instituteId}`,
			APPLICATION_COURSES: (applicationUuid: string) =>
				`${API_ROUTES.INSTITUTES}/applications/${applicationUuid}/application-courses`,
			CERTIFICATION_COURSES: (applicationUuid: string) =>
				`${API_ROUTES.INSTITUTES}/applications/${applicationUuid}/certification-courses`,
			/** Short-term / non-regular courses; path uses institute UUID (not application UUID). */
			NON_REGULAR_APPLICATION_COURSES: (instituteUuid: string | number) =>
				`${API_ROUTES.INSTITUTES}/applications/${instituteUuid}/application-courses/non-regular`,
			CHALLAN_COURSES: (applicationUuid: string) => `${API_ROUTES.INSTITUTES}/applications/${applicationUuid}/courses`,
			VALIDATE_CHALLAN: (applicationUuid: string) =>
				`${API_ROUTES.INSTITUTES}/applications/${applicationUuid}/validate-challan`,
			ADD_BULK_COURSES: (applicationId: string | number) =>
				`${API_ROUTES.INSTITUTES}/applications/${applicationId}/add-bulk-application-courses`,
			CERTIFICATE: (applicationUuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.CERTIFICATE(applicationUuid)}`,
			INSTITUTE_DETAIL: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.INSTITUTE_DETAIL(uuid)}`,
			BUILDING_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.BUILDING_DETAIL,
			APPLICATION_ATTACHMENT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.APPLICATION_ATTACHMENT,
			SUBMIT: (id: number) => `${API_ROUTES.INSTITUTES}/applications/${id}/submit`,
			ADD_COURSE_STREAM: (id: number) => `${API_ROUTES.INSTITUTES}/applications/${id}/add-course-stream`,
			RENEW_WITHOUT_TRADE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITHOUT_TRADE,
			RENEW: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW,
			RENEW_WITH_CHANGE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_CHANGE,
			RENEW_WITH_BUILDING_DETAILS:
				API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_BUILDING_DETAILS,
			RENEW_WITH_CHANGE_OF_NAME:
				API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_CHANGE_OF_NAME,
			RENEW_WITH_CHANGE_OF_ADDRESS:
				API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_CHANGE_OF_ADDRESS,
			RENEW_WITH_CHANGE_OF_OWNERSHIP:
				API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_CHANGE_OF_OWNERSHIP,
			RENEW_WITH_TRADE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.RENEW_WITH_TRADE,
			REFERBACK: (id: string | number) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.REFERBACK(id)}`,
			REFERBACK_INSTITUTE_DETAILS: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.REFERBACK_INSTITUTE_DETAILS(id)}`,
			UPDATE_INSTITUTE_DETAIL: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_INSTITUTE_DETAIL(id)}`,
			BASIC_DETAIL: (uuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.BASIC_DETAIL(uuid)}`,
			GET_BUILDING_DETAIL: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.GET_BUILDING_DETAIL(uuid)}`,
			GET_ATTACHMENT_DETAIL: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.GET_ATTACHMENT_DETAIL(uuid)}`,
			BASIC_DETAIL_WITH_SCRUTINY: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.BASIC_DETAIL_WITH_SCRUTINY(uuid)}`,
			BUILDING_DETAIL_WITH_SCRUTINY: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.BUILDING_DETAIL_WITH_SCRUTINY(uuid)}`,
			ATTACHMENT_DETAIL_WITH_SCRUTINY: (uuid: string) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.ATTACHMENT_DETAIL_WITH_SCRUTINY(uuid)}`,
			UPDATE_REFERBACK_FIELD: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_REFERBACK_FIELD(id)}`,
			RESUBMIT_REFERBACK: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.RESUBMIT_REFERBACK(id)}`,
			UPDATE_BASIC_DETAIL: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_BASIC_DETAIL(id)}`,
			UPDATE_BUILDING_DETAILS: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_BUILDING_DETAILS(id)}`,
			UPDATE_BUILDING_DETAIL: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_BUILDING_DETAIL(id)}`,
			UPDATE_ATTACHMENT_DETAILS: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_ATTACHMENT_DETAILS(id)}`,
			UPDATE_ATTACHMENT_DETAIL: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_ATTACHMENT_DETAIL(id)}`,
			UPDATE_COURSE_DETAIL: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_COURSE_DETAIL(id)}`,
			GET_APPLICATION_COURSES: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.GET_APPLICATION_COURSES(id)}`,
			GET_APPLICATION_COURSE: (id: string | number, applicationCourseId: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.GET_APPLICATION_COURSE(id, applicationCourseId)}`,
			UPDATE_APPLICATION_COURSE: (id: string | number, applicationCourseId: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_APPLICATION_COURSE(
					id,
					applicationCourseId,
				)}`,
			UPDATE_LAB_EQUIPMENTS: (id: string | number, applicationCourseId: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.UPDATE_LAB_EQUIPMENTS(id, applicationCourseId)}`,
			RESUBMIT_APPLICATION: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.RESUBMIT_APPLICATION(id)}`,
			RENEW_FOR_INSPECTION: `${API_ROUTES.INSTITUTES}/applications/renew-for-inspection`,
			APPEAL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.APPEAL,
			APPEALS_FOR_APPLICATION: (params: {
				instituteUuid: string;
				applicationUuid: string;
				page?: number;
				limit?: number;
			}) => {
				const page = params.page ?? 1;
				const limit = params.limit ?? 10;
				const search = new URLSearchParams({
					instituteUuid: params.instituteUuid,
					applicationUuid: params.applicationUuid,
					page: String(page),
					limit: String(limit),
				});
				return `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATIONS.APPEALS_LIST}?${search.toString()}`;
			},
			COURSES_WITH_SCRUTINY: (id: string | number) =>
				`${API_ROUTES.INSTITUTES}/applications/${id}/courses-with-scrutiny`,
		},
		INSTITUTE_APPLICATIONS: {
			ADMISSIONS: (instituteId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/applications`,
			LIST: (instituteId: string | number) =>
				`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_APPLICATIONS(instituteId)}`,
			APPROVE: `${API_ROUTES.INSTITUTES}/students/institute/approve-application`,
			REJECT: `${API_ROUTES.INSTITUTES}/students/institute/reject-application`,
			BULK_APPROVE: `${API_ROUTES.INSTITUTES}/students/institute/bulk-approve-application`,
			BULK_REJECT: `${API_ROUTES.INSTITUTES}/students/institute/bulk-reject-application`,
			INSTITUTES_FOR_MIGRATION: (instituteId: string | number, enrollmentId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/enrollments/${enrollmentId}/institutes-for-migration`,
			MIGRATE_STUDENT: `${API_ROUTES.INSTITUTES}/students/institute/migrate-student`,
			MIGRATION_REQUESTS: (instituteId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/migration-requests`,
			ACCEPT_MIGRATION_REQUEST: (instituteId: string | number, requestId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/migration-requests/${requestId}/accept`,
			REJECT_MIGRATION_REQUEST: (instituteId: string | number, requestId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/migration-requests/${requestId}/reject`,
			ENROLL: (applicationId: number) =>
				`${API_ROUTES.INSTITUTES}/students/applications/${applicationId}/enroll`,
			STATS: (instituteId: string | number) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/applications/stats`,
			MERIT_LIST: (instituteId: string | number, batchUuid: string) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/batches/${batchUuid}/merit-list`,
			MERIT_MARKS: (applicationUuid: string) =>
				`${API_ROUTES.INSTITUTES}/students/applications/${applicationUuid}/merit-marks`,
			ROLL_NUMBER_FORMAT: (instituteId: string | number, batchUuid: string) =>
				`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/batches/${batchUuid}/roll-number-format`,
		},
		DROPOUT_REASONS: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.DROPOUT_REASONS}`,
		STUDENT_DROPOUT: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_DROPOUT}`,
		STUDENT_DROPOUT_REVERT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_DROPOUT_REVERT(enrollmentUuid)}`,
		STUDENT_PROMOTION_BY_INSTITUTE: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_BY_INSTITUTE(instituteId)}`,
		STUDENT_PROMOTION_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_BY_ENROLLMENT(enrollmentUuid)}`,
		STUDENT_PROMOTION_PROMOTE: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_PROMOTE}`,
		STUDENT_PROMOTION_BULK_PROMOTE: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_BULK_PROMOTE}`,
		STUDENT_PROMOTION_REVERT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_REVERT(enrollmentUuid)}`,
		STUDENT_PROMOTION_HISTORY: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_PROMOTION_HISTORY(enrollmentUuid)}`,
		EMPLOYMENT_STATUS: `${API_ROUTES.INSTITUTES}/employments/status`,
		SESSION_STUDENTS: {
			SESSION: (sessionUuid: string) => `${API_ROUTES.INSTITUTES}/session-students/sessions/${sessionUuid}`,
			STUDENTS: (sessionUuid: string) =>
				`${API_ROUTES.INSTITUTES}/session-students/sessions/${sessionUuid}/students`,
			RESULT: (enrollmentUuid: string) =>
				`${API_ROUTES.INSTITUTES}/session-students/enrollments/${enrollmentUuid}/result`,
			COMPLETION: (enrollmentUuid: string) =>
				`${API_ROUTES.INSTITUTES}/session-students/enrollments/${enrollmentUuid}/completion`,
		},
		STUDENT_CERTIFICATES: {
			STUDENTS: (sessionUuid: string) =>
				`${API_ROUTES.INSTITUTES}/student-certificates/sessions/${sessionUuid}/students`,
			ISSUE: (enrollmentUuid: string) =>
				`${API_ROUTES.INSTITUTES}/student-certificates/enrollments/${enrollmentUuid}/issue`,
			CERTIFICATE: (certificateUuid: string) =>
				`${API_ROUTES.INSTITUTES}/student-certificates/${certificateUuid}`,
		},
		STUDENT_OUTCOME: (studentUuid: string) => `${API_ROUTES.INSTITUTES}/students/${studentUuid}/outcome`,
		STUDENT_EMPLOYMENTS: (studentUuid: string) => `${API_ROUTES.INSTITUTES}/students/${studentUuid}/employments`,
		STUDENT_EMPLOYMENT_BY_UUID: (studentUuid: string, employmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}/students/${studentUuid}/employments/${employmentUuid}`,
		PUBLIC_INSTITUTES: `${API_ROUTES.INSTITUTES}/public-institutes`,
		INCLUDING_PUBLIC: `${API_ROUTES.INSTITUTES}/institutes/including-public`,
		ORGANIZATION_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_TYPE,
		ORGANIZATION_CATEGORY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_CATEGORY,
		ORGANIZATION_COMPANY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_COMPANY,
		PROVINCE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVINCE,
		COUNTRY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COUNTRY,
		DIVISION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DIVISION,
		DISTRICT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DISTRICT,
		CITY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.CITY,
		TEHSIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.TEHSIL,
		UNION_COUNCIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.UNION_COUNCIL,
		NATIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.NATIONAL_ASSEMBLY,
		PROVISIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVISIONAL_ASSEMBLY,
		GENDER: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.GENDER,
		EDUCATION_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.EDUCATION_TYPE,
		CAMPUS_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.CAMPUS_TYPE,
		INSTITUTE_STREAM: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.INSTITUTE_STREAM,
		BANK: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.BANK,
		FACILITY_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FACILITY_TYPES,
		ATTACHMENT_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_TYPES,
		FILE_UPLOAD_URL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FILE_UPLOAD_URL,
		COURSE_STREAM: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_STREAM,
		COURSE_LIST: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_LIST,
		COURSE_BY_UUID: (courseUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_BY_UUID(courseUuid)}`,
		PUBLIC_COURSE_LIST: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PUBLIC_COURSE_LIST,
		ASSIGNED_COURSES: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.ASSIGNED_COURSES(instituteId)}`,
		QUALIFICATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.QUALIFICATION,
		DESIGNATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DESIGNATION,
		TECHNOLOGY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.TECHNOLOGY,
		COURSE_LABS: (courseId: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_LABS}/${courseId}/labs`,
		LAB_BY_UUID: (labUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.LAB_BY_UUID(labUuid)}`,
		FACULTY: (instituteUuid: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.LIST(instituteUuid)}`,
		ADD_FACULTY: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.ADD}`,
		UPDATE_FACULTY: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.UPDATE}`,
		DELETE_FACULTY: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.DELETE}`,
		ADD_FACULTY_EDUCATION: (facultyId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.ADD_EDUCATION(facultyId)}`,
		UPDATE_FACULTY_EDUCATION: (facultyId: string | number, educationId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.UPDATE_EDUCATION(facultyId, educationId)}`,
		ADD_FACULTY_CERTIFICATE: (facultyMemberId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.ADD_CERTIFICATE(facultyMemberId)}`,
		UPDATE_FACULTY_CERTIFICATE: (facultyMemberId: string | number, certificateId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY.UPDATE_CERTIFICATE(facultyMemberId, certificateId)}`,
		BATCHES: (instituteId: string | number) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.BATCHES(instituteId)}`,
		TRADE_SESSION_STUDENTS: (sessionUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.TRADE_SESSION_STUDENTS(sessionUuid)}`,
		STUDENT_ATTENDANCE: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_ATTENDANCE}`,
		STUDENT_ATTENDANCE_BULK: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.STUDENT_ATTENDANCE_BULK}`,
		ENROLLMENT_ATTENDANCES_BY_SUBJECT: (enrollmentUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.ENROLLMENT_ATTENDANCES_BY_SUBJECT(enrollmentUuid)}`,
		FACULTY_ATTENDANCE: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY_ATTENDANCE}`,
		FACULTY_ATTENDANCE_BULK: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY_ATTENDANCE_BULK}`,
		FACULTY_ATTENDANCE_BY_FACULTY_AND_INSTITUTE: (facultyMemberUuid: string, instituteUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY_ATTENDANCE_BY_FACULTY_AND_INSTITUTE(facultyMemberUuid, instituteUuid)}`,
		FACULTY_ATTENDANCE_DETAILS: (facultyMemberUuid: string, instituteUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY_ATTENDANCE_DETAILS(facultyMemberUuid, instituteUuid)}`,
		FACULTY_MEMBER_ATTENDANCES_BY_SUBJECT: (facultyMemberUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.FACULTY_MEMBER_ATTENDANCES_BY_SUBJECT(facultyMemberUuid)}`,
		RESULT_STUDENTS: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.RESULT_STUDENTS(instituteId)}`,
		INSTITUTE_STUDENTS_WITH_OUTCOMES: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENTS_WITH_OUTCOMES(instituteId)}`,
		INSTITUTE_STUDENT_OUTCOME: (instituteId: string | number, studentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENT_OUTCOME(instituteId, studentUuid)}`,
		INSTITUTE_STUDENT_EMPLOYMENTS: (instituteId: string | number, studentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENT_EMPLOYMENTS(instituteId, studentUuid)}`,
		INSTITUTE_STUDENT_EMPLOYMENT_BY_ID: (
			instituteId: string | number,
			studentUuid: string,
			employmentId: string,
		) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENT_EMPLOYMENT_BY_ID(instituteId, studentUuid, employmentId)}`,
		INSTITUTE_STUDENT_HIGHER_STUDIES: (instituteId: string | number, studentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENT_HIGHER_STUDIES(instituteId, studentUuid)}`,
		INSTITUTE_STUDENT_HIGHER_STUDY_BY_ID: (
			instituteId: string | number,
			studentUuid: string,
			studyId: string,
		) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.INSTITUTE_STUDENT_HIGHER_STUDY_BY_ID(instituteId, studentUuid, studyId)}`,
		EMPLOYERS: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.EMPLOYERS}`,
		OUTCOME_JOB_TYPES: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.OUTCOME_JOB_TYPES}`,
		COURSE_RESULT_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_RESULT_BY_ENROLLMENT(enrollmentUuid)}`,
		COURSE_RESULT: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_RESULT}`,
		COURSE_RESULT_BY_UUID: (resultUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_RESULT_BY_UUID(resultUuid)}`,
		CBTA_COURSE_RESULT_BY_ENROLLMENT: (enrollmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.CBTA_COURSE_RESULT_BY_ENROLLMENT(enrollmentUuid)}`,
		CBTA_COURSE_RESULT: `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.CBTA_COURSE_RESULT}`,
		CBTA_COURSE_RESULT_MODULE: (moduleResultUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.CBTA_COURSE_RESULT_MODULE(moduleResultUuid)}`,
		CBTA_COURSE_RESULT_HEADER: (headerUuid: string) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.CBTA_COURSE_RESULT_HEADER(headerUuid)}`,
		ATTACHMENT_UPLOAD: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_UPLOAD,
		ATTACHMENT_PREVIEW: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_PREVIEW,
		AFFIDAVIT_GET: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.AFFIDAVIT_GET,
		APPLICATION_COURSE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATION_COURSE,
		DRAFT_APPLICATIONS: (limit: number, page: number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.APPLICATION_DRAFT}?limit=${limit}&page=${page}`,
		INSTITUTE_OVERVIEW_STATS: `${API_ROUTES.INSTITUTES}/dashboard/institute-overview-stats`,
		CAPACITY_STATS: `${API_ROUTES.INSTITUTES}/dashboard/capacity-stats`,
		SESSION_MONITOR: `${API_ROUTES.INSTITUTES}/dashboard/session-monitor`,
		SESSION_MONITOR_COURSES: `${API_ROUTES.INSTITUTES}/dashboard/session-monitor/courses`,
	},
	INSTITUTE: {
		GET_APPLICATION_SESSIONS: `${API_ROUTES.INSTITUTES}/system/filters/application-sessions`,
		GET_TERMS: (page: number, limit: number) => `${API_ROUTES.INSTITUTES}/terms?page=${page}&limit=${limit}`,
		GET_INSTITUTE_SHIFTS: (instituteId: number, courseId: string) =>
			`${API_ROUTES.INSTITUTES}/students/institute/${instituteId}/shifts?courseId=${courseId}`,
		GET_ASSESSMENT_BODIES: `${API_ROUTES.INSTITUTES}/assessment-body`,
		GET_TEACHING_MODES: (page: number, limit: number) =>
			`${API_ROUTES.INSTITUTES}/teaching-mode?page=${page}&limit=${limit}`,
		GET_FEE_MODES: (page: number, limit: number) =>
			`${API_ROUTES.INSTITUTES}/fee-mode?page=${page}&limit=${limit}`,
		CREATE_TRADE_SESSION: `${API_ROUTES.INSTITUTES}/trade-session`,
		GET_MATCHED_TRADES: `${API_ROUTES.INSTITUTES}/trade-session/matched-trades`,
		GET_SESSION_DEFAULTS: `${API_ROUTES.INSTITUTES}/trade-session/session-defaults`,
		GET_COURSE_CONTENTS: (courseUuid: string) => `${API_ROUTES.INSTITUTES}/course/${courseUuid}/contents`,
		GET_ALLOTTED_CAPACITY: (instituteId: string, tradeId: string, academicYearSessionId: string, shiftId: string) =>
			`${API_ROUTES.INSTITUTES}/trade-session/allotted-capacity?instituteId=${instituteId}&tradeId=${tradeId}&academicYearSessionId=${academicYearSessionId}&shiftId=${shiftId}`,
		GET_TRADE_SESSIONS: (page: number, limit: number) =>
			`${API_ROUTES.INSTITUTES}/trade-session?page=${page}&limit=${limit}`,
		OJT_SESSION_SUMMARY: (sessionUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/sessions/${sessionUuid}/summary`,
		OJT_SESSION_STUDENTS: (sessionUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/sessions/${sessionUuid}/students`,
		OJT_EXTERNAL_EMPLOYERS: (sessionUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/sessions/${sessionUuid}/external-employers`,
		OJT_ASSIGNMENTS: (sessionUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/sessions/${sessionUuid}/assignments`,
		OJT_ASSIGNMENTS_BULK: (sessionUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/sessions/${sessionUuid}/assignments/bulk`,
		OJT_ASSIGNMENT: (assignmentUuid: string) =>
			`${API_ROUTES.INSTITUTES}/ojt/assignments/${assignmentUuid}`,
		GET_SESSION_STATUSES: `${API_ROUTES.INSTITUTES}/trade-session/session-statuses`,
		GET_CERTIFIED_INSTITUTES: `${API_ROUTES.INSTITUTES}/institutes/certified`,
		GET_INSTITUTE_COURSES: (instituteId: number | string, page = 1, limit = 100) =>
			`${API_ROUTES.INSTITUTES}/${instituteId}/institute-courses?page=${page}&limit=${limit}`,
		GET_INSTITUTE_COURSES_WITH_PENDING: (instituteId: number | string, page = 1, limit = 100) =>
			`${API_ROUTES.INSTITUTES}/${instituteId}/institute-courses/with-pending?page=${page}&limit=${limit}`,
	},
	COURSES: {
		COURSES: API_ROUTES.COURSES,
		EQUIPMENT: (courseId: string) => `${API_ROUTES.COURSES}/${courseId}${API_PATHS.COURSES.EQUIPMENT}`,
		INSTITUTE_COURSES_BY_ID: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.COURSES.INSTITUTE_COURSES_BY_ID(instituteId)}`,
		INSTITUTE_COURSES_WITH_CREATED_SESSION: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}/${instituteId}/institute-courses/with-created-session`,
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: (instituteId: string | number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.E_CHALLAN_SUMMARY.E_CHALLANS(instituteId)}`,
	},
	APPLICATIONS: {
		APPLICATIONS: API_ROUTES.APPLICATIONS,
	},
	E_CHALLAN_STATUSES: {
		E_CHALLAN_STATUS: (type: string, page: number) =>
			`${API_PATHS.E_CHALLAN_STATUS.E_CHALLAN_STATUS}?type=${type}&page=${page}`,
		CHALLANS: (status: string, page: number, limit: number) =>
			`${API_ROUTES.INSTITUTES}${API_PATHS.E_CHALLAN_STATUS.CHALLANS}?status=${status}&page=${page}&limit=${limit}`,
	},
	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS_BYID: API_ROUTES.INSTITUTES + `${API_ROUTES.TRACK_APPLICATIONS_BY_ID}`,
		TRACK_APPLICATIONS: API_ROUTES.INSTITUTES + API_ROUTES.TRACK_APPLICATIONS,
		TRACK_APPLICATION: (id: string | number) => `${API_ROUTES.INSTITUTES}/applications/${id}/track`,
	},
	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
} as const;

export const QUERY_KEYS = {
	APPLICATION_SESSIONS: "application-sessions",
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
	},
	COURSES: {
		COURSES: "courses",
		EQUIPMENT: "course-equipment",
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: "e-challan-summary",
	},
	APPLICATIONS: {
		APPLICATIONS: "applications",
		DETAILS: "application-detail",
		REFERBACK: "referback-application",
		REFERBACK_INSTITUTE_DETAILS: "referback-institute-details",
		REFERBACK_BUILDING_DETAILS: "referback-building-details",
		REFERBACK_ATTACHMENT_DETAILS: "referback-attachment-details",
		REFERBACK_COURSES_WITH_SCRUTINY: "referback-courses-with-scrutiny",
		MERIT_LIST: "merit-list",
	},
	E_CHALLAN_STATUSES: {
		E_CHALLAN_STATUS: "e-challan-status",
		CHALLANS: "e-challan-challans",
	},
	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS: "track-applications",
	},
	INSTITUTES: {
		INSTITUTE_OVERVIEW_STATS: "institute-overview-stats",
		CAPACITY_STATS: "capacity-stats",
		SESSION_MONITOR: "session-monitor",
		SESSION_MONITOR_COURSES: "session-monitor-courses",
		ACADEMIC_CALENDARS: "academic-calendars",
		TRADE_SESSIONS: "trade-sessions",
		OJT_SESSION_SUMMARY: "ojt-session-summary",
		OJT_SESSION_STUDENTS: "ojt-session-students",
		OJT_EXTERNAL_EMPLOYERS: "ojt-external-employers",
		MATCHED_TRADES: "matched-trades",
		SESSION_DEFAULTS: "session-defaults",
		COURSE_CONTENTS: "course-contents",
		SESSION_STATUSES: "session-statuses",
		COURSES: "institute-session-courses",
		CERTIFIED_INSTITUTES: "certified-institutes",
		INSTITUTE_COURSES_WITH_PENDING: "institute-session-courses-with-pending",
		SHIFTS: "shifts",
		ALLOTTED_CAPACITY: "allotted-capacity",
		APPLICATIONS: {
			RECENT: "recent-application",
			APPLICATION_COURSES: "application-courses",
			NON_REGULAR_APPLICATION_COURSES: "non-regular-application-courses",
		},
		ATTACHMENT_PREVIEW: "attachment-preview",
		MY_INSTITUTES: "my-institutes",
		CHECK_DUPLICATE_FIELD: "check-duplicate-field",
		ORGANIZATION_TYPE: "organization-types",
		PUBLIC_INSTITUTES: "public-institutes",
		INCLUDING_PUBLIC: "including-public-institutes",
		ORGANIZATION_CATEGORY: "organization-categories",
		ORGANIZATION_COMPANY: "organization-companies",
		PROVINCE: "provinces",
		DIVISION: "divisions",
		DISTRICT: "districts",
		CITY: "cities",
		TEHSIL: "tehsils",
		UNION_COUNCIL: "union-councils",
		NATIONAL_ASSEMBLY: "national-assemblies",
		PROVISIONAL_ASSEMBLY: "provisional-assemblies",
		GENDER: "gender",
		EDUCATION_TYPE: "education-type",
		CAMPUS_TYPE: "campus-type",
		INSTITUTE_STREAM: "institute-stream",
		BANK: "bank",
		FACILITY_TYPES: "facility-types",
		ATTACHMENT_TYPES: "attachment-types",
		COURSE_STREAM: "course-stream",
		COURSE_LIST: "course-list",
		ASSIGNED_COURSES: "assigned-courses",
		QUALIFICATION: "qualification",
		QUALIFICATION_LEVEL: "qualification-level",
		DESIGNATION: "designation",
		TECHNOLOGY: "technology",
		COURSE_LABS: "course-labs",
		LAB_DETAIL: "lab-detail",
		ATTACHMENT_UPLOAD: "attachment-upload",
		AFFIDAVIT_GET: "affidavit-get",
		APPLICATION_COURSE: "application-course",
		FACULTY_LIST: "faculty-list",
		BATCHES: "batches",
		ROLL_NUMBER_FORMAT: "roll-number-format",
		ADMISSION_QUOTA: "admission-quota",
		TRADE_SESSION_STUDENTS: "trade-session-students",
		STUDENT_ATTENDANCE: "student-attendance",
		ENROLLMENT_ATTENDANCES_BY_SUBJECT: "enrollment-attendances-by-subject",
		FACULTY_ATTENDANCE: "faculty-attendance",
		FACULTY_ATTENDANCE_BY_FACULTY_AND_INSTITUTE: "faculty-attendance-by-faculty-and-institute",
		FACULTY_MEMBER_ATTENDANCES_BY_SUBJECT: "faculty-member-attendances-by-subject",
		RESULT_STUDENTS: "result-students",
		SESSION_STUDENTS: "session-students",
		SESSION_STUDENT_RESULT: "session-student-result",
		STUDENT_CERTIFICATES: "student-certificates",
		COURSE_RESULT: "course-result",
		CBTA_COURSE_RESULT: "cbta-course-result",
	},
	DRAFT_APPLICATIONS: "draft-applications",
	APPLICATIONS_APPEALS: "applications-appeals",
	PROMOTION: {
		LIST: "student-promotion-list",
		HISTORY: "student-promotion-history",
	},
	MIGRATION_REQUESTS: "migration-requests",
	EMPLOYMENT_STATUS: {
		STATUSES: "employment-statuses",
		EMPLOYMENT_ACTIVITY: "employment-activity",
		INSTITUTE_EMPLOYMENTS: "employment-institute-employments",
		INSTITUTE_HIGHER_STUDIES: "employment-institute-higher-studies",
		INSTITUTE_STUDENTS: "employment-institute-students",
		EMPLOYERS: "employment-employers",
		OUTCOME_JOB_TYPES: "employment-outcome-job-types",
		COUNTRIES: "employment-countries",
		DISTRICTS: "employment-districts",
		CITIES: "employment-cities",
	},
};
export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
	SERVER_ROUTES.AUTH.VERIFY_RESET_TOKEN,
	SERVER_ROUTES.AUTH.RESEND_VERIFICATION_LINK,
];

/** Errors handled in the UI (inline notes/fields), not as global toasts. */
export const CLIENT_HANDLED_ERROR_ENDPOINTS = [
	SERVER_ROUTES.INSTITUTES.CHECK_DUPLICATE_FIELD,
	SERVER_ROUTES.INSTITUTE.GET_SESSION_DEFAULTS,
];
